import React from "react";
import {
  List,
  ShowButton,
  SimpleShowLayout,
  Datagrid,
  TextField,
  DateField,
  FunctionField,
} from "react-admin";
import {
    WeekdaysField,
    DoctorReferenceField,
    PatientReferenceField,
    DeviceFamilyField,
} from "../../misc/customFields";

import SessionShow from "./utils";
import withStyles from "@material-ui/core/styles/withStyles";
import PeriodizationAside from "./PeriodizationAside";
import {SessionFilterWithDeviceFamily} from '../../misc/filters';


export const ScheduledSessionsList = props => {
  return (
    <List {...props} filters={<SessionFilterWithDeviceFamily />} bulkActionButtons={null}>
      <Datagrid>
        <ShowButton />
        <TextField source="id" />
        <DateField source="created" showTime label="Created" />
        <DoctorReferenceField sortBy="doctor__first_name"  label="Clinician"/>
        <PatientReferenceField label="Patient" source="patient"/>
        <DeviceFamilyField label="Device Family" />
        <TextField source="stimulationMode" label="Mode" />
        <TextField source="sessionType" label="Session Type" />
        <FunctionField
          label="Duration"
          sortBy="durationDays"
          render={record => {
            if (!record.durationDays) {
              return "";
            }
            const weekNumber = parseInt(record.durationDays / 7);
            if (weekNumber >= 1) {
              return `${weekNumber} weeks`;
            }
            return `${record.durationDays} days`;
          }}
        />
        <WeekdaysField label="Periodization" />
        <TextField source="programName" label="Program" sortable={false} />
        <TextField
          source="muscleGroupName"
          label="Muscle Group"
          sortable={false}
        />
        <DateField
          source="nextFollowingDate"
          label="Next Following Date"
          sortable={false}
        />
      </Datagrid>
    </List>
  );
};
const editStyles = {
  root: { alignItems: "flex-start" }
};

const ScheduledSessionsShow_ = props => {
  return (
    <SessionShow
      {...props}
      aside={<PeriodizationAside />}
      showTitle="Session Info"
    >
      <SimpleShowLayout>
        <TextField source="id" />
        <DateField source="created" showTime label="Created" />
        <DoctorReferenceField sortBy="doctor__first_name" label="Clinician" allowEmpty />
        <PatientReferenceField label="Patient" />
        <TextField source="stimulationMode" label="Mode" />
        <TextField source="sessionType" label="Session Type" />
        <FunctionField
          label="Duration"
          sortBy="durationDays"
          render={record => {
            if (!record.durationDays) {
              return "";
            }
            const weekNumber = parseInt(record.durationDays / 7);
            if (weekNumber >= 1) {
              return `${weekNumber} weeks`;
            }
            return `${record.durationDays} days`;
          }}
        />
        <TextField source="programName" label="Program" />
        <TextField source="muscleGroupName" label="Muscle Group" />
        <DateField source="nextFollowingDate" label="Next Following Date" />
      </SimpleShowLayout>
    </SessionShow>
  );
};

export const ScheduledSessionsShow = withStyles(editStyles)(
  ScheduledSessionsShow_
);
